module.exports = __webpack_public_path__ + "img/cle3.8170fd58.png";